import gql from "graphql-tag";

export const GET_INTEGRATION = gql`
    query Integration($integrationId: ID!){
        integration(integrationId: $integrationId) {
            integrationId
            userId
            integrationName
            integrationDescription
            createdAt
            updatedAt
        }
    }
`;

export const GET_INTEGRATIONS = gql`
    query Integrations($searchStr: String, $limit: Int, $offset: Int, $orderList: [String]){
        integrations(searchStr: $searchStr, limit: $limit, offset: $offset, orderList: $orderList) {
            integrationId
            userId
            integrationName
            integrationDescription
            createdAt
            updatedAt
        }
    }
`;

export const GET_INTEGRATIONS_OF_PARENT = gql`
    query IntegrationOfParent($parentType: String!, $parentId: ID!, $searchStr: String, $limit: Int, $offset: Int, $orderList: [String]){
        integrationOfParent(parentType: $parentType, parentId: $parentId, searchStr: $searchStr, limit: $limit, offset: $offset, orderList: $orderList) {
            integrationId
            userId
            integrationName
            integrationDescription
            createdAt
            updatedAt
        }
    }
`;

export const CREATE_INTEGRATION = gql`
    mutation CreateIntegration($newIntegration: newIntegration!) {
        createIntegration(
            newIntegration: $newIntegration
        ) {
            returnCode
            message
            id
            name
        }
    }
`;

export const UPDATE_INTEGRATION = gql`
    mutation UpdateIntegration($changedIntegration: changedIntegration!) {
        updateIntegration(
            changedIntegration: $changedIntegration
        ) {
            returnCode
            message
        }
    }
`;

export const DELETE_INTEGRATION = gql`
    mutation DeleteIntegration($integrationId: ID!) {
        deleteIntegration(
            deleteIntegrationId: $integrationId
        ) {
            returnCode
            message
        }
    }
`;
